// The NAVBAR for the application
import {FaHome, FaSignInAlt, FaSignOutAlt, FaClock} from 'react-icons/fa'
import {Link, useNavigate, useLocation} from "react-router-dom"
import {useDispatch, useSelector} from 'react-redux'
import {logoutWorker, resetWorkerUser} from '../features/workerAuth/workerAuthSlice'
import React from 'react';
import useLogout from '../hooks/useLogout';

function Header (){
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Hooks to get the user and workerUser from the redux store. User is for business login, workerUser is for worker login. We will use these to conditionally render the nav bar buttons and to determine where to navigate when the logo is clicked.
    const {user} = useSelector((state)=> state.auth)
    const {workerUser} = useSelector((state)=> state.workerAuth)
    const onLogout = useLogout();

    // Homedash has its own sidebar with navigation and logout — Header is not needed there
    if (location.pathname.startsWith('/homedash')) return null;

    const handleLogoClick = () => {
        if (user) {
            navigate('/homedash');
        } else if (workerUser) {
            navigate('/workerDash');
        } else {
            navigate('/');
        }
    };

    //logout worker
    const onWorkerLogout =()=>{
        
        dispatch(logoutWorker())     //removes the workerUser data from local storage
        dispatch(resetWorkerUser())  //resents the redux state to initial state for slice workerAuth
        navigate("/workerLogin")
    }

    // Navigate to worker dashboard
    const onWorkerDash = () => {
        navigate("/workerDash")
    }

    return(
       
<header className="flex flex-col md:flex-row items-center justify-between px-4 py-2 bg-surface border-b border-border md:mb-0">

    {/* Logo - Visible on all screens */}
    <div className="flex-shrink-0 mb-2 md:mb-0">
        <button
            className='flex items-center bg-transparent border-0 p-0 cursor-pointer font-mono font-bold uppercase md:text-2xl text-ink text-3xl tracking-widest'
            onClick={handleLogoClick}
            aria-label="TimeStat Home"
        >
            <span>TimeStat</span>
            {(user || workerUser) && (
                <FaHome className="ml-2 text-ink-3 text-2xl" aria-label="Home Icon" />
            )}
        </button>
    </div>

    {/* NavBar Buttons for larger screens */}
    <div className='hidden md:flex'>
        <ul className='flex space-x-2'>
            {!user && !workerUser && (
            <>
                <li className='flex'>
                    <Link className="text-ink-2 hover:bg-surface-2 px-3 py-1 rounded-md text-label transition" to="/login" aria-label="Business Login">
                        <FaSignInAlt className="inline-block mr-1" /> Business
                    </Link>
                </li>
                <li className='flex'>
                    <Link className="text-ink-2 hover:bg-surface-2 px-3 py-1 rounded-md text-label transition" to="/workerLogin" aria-label="Worker Login">
                        <FaClock className="inline-block mr-1" /> Worker
                    </Link>
                </li>
            </>
            )}

            {workerUser && (
                <>
                    {location.pathname === "/" && (
                        <li>
                            <button
                                className="text-ink-2 hover:bg-surface-2 px-3 py-1 rounded-md text-label transition"
                                onClick={onWorkerDash}
                                aria-label="Worker Dashboard"
                            >
                                Dashboard
                            </button>
                        </li>
                    )}
                    <li>
                        <button
                            className="text-ink-2 hover:bg-surface-2 px-3 py-1 rounded-md text-label transition"
                            onClick={onWorkerLogout}
                            aria-label="Log Out Worker"
                        >
                            Log Out
                        </button>
                    </li>
                </>
            )}

            {user && (
                <li className='flex'>
                    <button
                        className="text-ink-2 hover:bg-surface-2 px-3 py-1 rounded-md text-label transition"
                        onClick={onLogout}
                        aria-label="Log Out"
                    >
                        <FaSignOutAlt className="inline-block mr-1" /> Log Out
                    </button>
                </li>
            )}
        </ul>
    </div>
</header>
    )
}

export default Header